import { useEffect } from "react";
import DefaultPage from "pages/container/DefaultPage";
import { CircularProgress, Stack } from "@mui/joy";
import useLoginPromotion from "../../hooks/useLoginPromotion";
import { decodeJWT } from "../../utils/jwtUtils";
import { PATH } from "../../routes/paths";
import { useNavigate } from "react-router-dom";

export default function AppleLoginPromotionRedirect() {
  const navigate = useNavigate();
  const hashParams = window.location.hash.substring(1).split("&");
  const idTokenParam = hashParams.find((param) =>
    param.startsWith("id_token=")
  );
  const idToken = idTokenParam ? idTokenParam.split("=")[1] : null;

  // Decode JWT to extract email
  const decodedToken = idToken ? decodeJWT(idToken) : null;
  const email = decodedToken?.email || undefined;

  const { login, error } = useLoginPromotion({
    url: `/user/v2/login`,
    idToken: idToken!!,
    type: "apple",
    email: email,
  });

  useEffect(() => {
    if (idToken) {
      login();
    }
  }, [idToken]);

  useEffect(() => {
    if (error) {
      navigate(PATH.promotionLogin, { replace: true });
    }
  }, [error]);

  return (
    <DefaultPage
      content={
        <Stack alignItems={"center"}>
          <CircularProgress color="neutral" />
        </Stack>
      }
    />
  );
}
